import { SessionEnvironmentError } from './errors';

/** 要求を送った時点で、このタブが持っていたセッション。 */
export type HeldSession = { session: string | null; generation: string | null };

/** タブ間で更新・ログイン・ログアウトを1つずつにするための Web Locks の名前。 */
const REFRESH_LOCK = 'yometel-admin-token-refresh';

type LockManagerLike = {
  request: (name: string, callback: () => Promise<unknown>) => Promise<unknown>;
};

function getLockManager(): LockManagerLike | null {
  const locks = typeof navigator !== 'undefined' ? (navigator as any).locks : undefined;
  return locks && typeof locks.request === 'function' ? locks : null;
}

/**
 * Cookie を書き換えうる処理（更新・ログイン・ログアウト）を、タブ間で1つずつにする。
 *
 * 更新の応答（回転した Cookie）とログイン・ログアウトの応答が入れ違うと、ログアウト
 * 後に使える Cookie が残ったり、新しいログインの Cookie が前のセッションのもので
 * 上書き・削除されたりする。Web Locks が無ければ実行しない（SessionEnvironmentError）。
 * 管理画面は https か localhost でだけ使う方針（PR #90 レビュー P2、2026-10-04）。
 */
export function withSessionLock<T>(fn: () => Promise<T>): Promise<T> {
  const locks = getLockManager();
  if (!locks) return Promise.reject(new SessionEnvironmentError());
  return locks.request(REFRESH_LOCK, fn) as Promise<T>;
}
